<template>
  <div>
    <van-button size="large" icon="service-o" v-if="enableBell()" @click="cmdServiceType">
      服務鈴 {{ $route.query.tblid }}
    </van-button>
    <ServiceType ref="rServiceType" />
  </div>
</template>

<style scoped>
.van-button {
  background-color: v-bind(sGetConfig("color3"));
  color: white;
  /* border-radius: 2rem; */
  margin: 0.5%;
  width: 99%;
  /* height: 44px; */
  font-size: 1rem;
  z-index: 2;
}
</style>
<script>
const fits = require("../../mixin/lib-fits-front");
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    enableBell() {
      let tblid = fits.str(this.$route.query.tblid);
      if (this.sGetConfig("bell") && this.sGetConfig("chkIndexTopBell") && tblid != "")
        return true;
      else return false;
    },

    cmdServiceType() {
      this.$refs.rServiceType.show();
    },
  },
};
</script>
